import { render, staticRenderFns } from "./RegisterConfigLevels.vue?vue&type=template&id=40b8afa6&scoped=true&"
import script from "./RegisterConfigLevels.vue?vue&type=script&lang=js&"
export * from "./RegisterConfigLevels.vue?vue&type=script&lang=js&"
import style0 from "./RegisterConfigLevels.vue?vue&type=style&index=0&id=40b8afa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b8afa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
